(function(){
  'use strict';

  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  function isDesktop(){return window.matchMedia?window.matchMedia('(min-width:1025px)').matches:window.innerWidth>=1025;}
  function q(root,sel){return (root||document).querySelector(sel);}
  function qa(root,sel){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}

  var popover=null;
  var activeTrigger=null;
  var hideTimer=0;

  function ensurePopover(){
    if(popover&&document.body.contains(popover))return popover;
    popover=document.createElement('div');
    popover.className='lbx101-store-popover';
    popover.setAttribute('role','dialog');
    popover.setAttribute('aria-label','Disponibilidad por tienda');
    popover.setAttribute('aria-hidden','true');
    popover.innerHTML=''+
      '<div class="lbx101-store-popover__head"><span><strong>Disponibilidad por tienda</strong><small data-lbx101-store-summary></small></span><button type="button" data-lbx101-store-close aria-label="Cerrar">×</button></div>'+
      '<div class="lbx101-store-popover__list" data-lbx101-store-list></div>';
    document.body.appendChild(popover);
    popover.addEventListener('mouseenter',function(){window.clearTimeout(hideTimer);});
    popover.addEventListener('mouseleave',scheduleClose);
    q(popover,'[data-lbx101-store-close]').addEventListener('click',closePopover);
    return popover;
  }

  function stockPanelFor(trigger){
    var hub=trigger&&trigger.closest('[data-lbx-stock-hub]');
    return hub?q(hub,'[data-lbx-store-stock-panel]'):null;
  }

  function readRows(panel){
    if(!panel)return [];
    var list=q(panel,'[data-lbx-store-stock-list]');
    if(!list)return [];
    var rows=qa(list,'.lbx-store-stock__row').map(function(row){
      var name=q(row,'b');
      var note=q(row,'small');
      var qty=q(row,':scope > strong');
      return {
        name:name?String(name.textContent||'').trim():'',
        note:note?String(note.textContent||'').trim():'',
        qty:qty?String(qty.textContent||'').trim():''
      };
    }).filter(function(row){return row.name||row.qty;});

    /* Some stock payloads contain the same store twice, for example
       "Madrid" and "Madrid:".  The storefront must show one row per
       physical location, never double-count the same inventory. */
    var unique={};
    rows.forEach(function(row){
      var key=String(row.name||'')
        .toLowerCase()
        .replace(/^labosch\s+/,'')
        .replace(/[\s:;,.\-–—_]+/g,'')
        .trim();
      if(!key)key='stock';
      if(!unique[key]){
        unique[key]=row;
        return;
      }
      var oldQty=parseInt(String(unique[key].qty||'').replace(/\D+/g,''),10)||0;
      var newQty=parseInt(String(row.qty||'').replace(/\D+/g,''),10)||0;
      if(newQty>oldQty)unique[key]=row;
    });
    return Object.keys(unique).map(function(key){return unique[key];});
  }

  function getOwnStock(trigger){
    var title=q(trigger,'[data-lbx-fast-stock-title]');
    var text=title?String(title.textContent||''):'';
    var match=text.match(/(\d+)/);
    return match?parseInt(match[1],10):0;
  }

  function buildContent(trigger){
    var panel=stockPanelFor(trigger);
    var rows=readRows(panel);
    var summary=panel?q(panel,'[data-lbx-store-stock-summary]'):null;
    var summaryText=summary?String(summary.textContent||'').trim():'';
    if(!rows.length){
      var own=getOwnStock(trigger);
      if(own>0){
        rows=[{name:'Stock físico LaBosch',note:'El detalle por tienda todavía no está sincronizado para esta variante.',qty:String(own)}];
        summaryText=own===1?'1 unidad física':own+' unidades físicas';
      }
    }
    return {rows:rows,summary:summaryText};
  }

  function positionPopover(trigger){
    var box=ensurePopover();
    var r=trigger.getBoundingClientRect();
    var width=Math.min(390,window.innerWidth-32);
    box.style.width=width+'px';
    box.style.maxWidth=width+'px';
    var measured=box.offsetHeight||190;
    var left=Math.max(16,Math.min(r.left,window.innerWidth-width-16));
    var top=r.bottom+10;
    if(top+measured>window.innerHeight-16)top=Math.max(16,r.top-measured-10);
    box.style.left=left+'px';
    box.style.top=top+'px';
  }

  function openPopover(trigger){
    if(!isDesktop()||!trigger)return;
    var content=buildContent(trigger);
    if(!content.rows.length)return;
    window.clearTimeout(hideTimer);
    var box=ensurePopover();
    var summary=q(box,'[data-lbx101-store-summary]');
    var list=q(box,'[data-lbx101-store-list]');
    if(summary)summary.textContent=content.summary||((content.rows.length===1)?'1 tienda':' '+content.rows.length+' tiendas');
    if(list){
      list.innerHTML=content.rows.map(function(row){
        return '<div class="lbx101-store-popover__row"><span><b>'+escapeHtml(row.name)+'</b>'+(row.note?'<small>'+escapeHtml(row.note)+'</small>':'')+'</span><strong>'+escapeHtml(row.qty)+'</strong></div>';
      }).join('');
    }
    activeTrigger=trigger;
    positionPopover(trigger);
    box.classList.add('is-open');
    box.setAttribute('aria-hidden','false');
    trigger.setAttribute('aria-expanded','true');
  }

  function escapeHtml(value){return String(value||'').replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch];});}

  function closePopover(){
    window.clearTimeout(hideTimer);
    if(popover){popover.classList.remove('is-open');popover.setAttribute('aria-hidden','true');}
    if(activeTrigger)activeTrigger.setAttribute('aria-expanded','false');
    activeTrigger=null;
  }

  function scheduleClose(){
    window.clearTimeout(hideTimer);
    hideTimer=window.setTimeout(function(){
      if(popover&&popover.matches(':hover'))return;
      if(activeTrigger&&activeTrigger.matches(':hover'))return;
      closePopover();
    },140);
  }

  function enhanceStock(){
    if(!isDesktop())return;
    qa(document,'[data-lbx-fast-stock]').forEach(function(trigger){
      if(trigger.dataset.lbx101StockReady==='1')return;
      trigger.dataset.lbx101StockReady='1';
      trigger.setAttribute('tabindex','0');
      trigger.setAttribute('aria-haspopup','dialog');
      trigger.setAttribute('aria-expanded','false');
      trigger.removeAttribute('title');
      trigger.addEventListener('mouseenter',function(){openPopover(trigger);});
      trigger.addEventListener('mouseleave',scheduleClose);
      trigger.addEventListener('focus',function(){openPopover(trigger);});
      trigger.addEventListener('blur',scheduleClose);
      trigger.addEventListener('click',function(e){
        var content=buildContent(trigger);
        if(!content.rows.length)return;
        e.preventDefault();
        if(activeTrigger===trigger&&popover&&popover.classList.contains('is-open'))closePopover();
        else openPopover(trigger);
      });
    });
  }

  function init(){enhanceStock();}
  ready(init);
  window.addEventListener('load',init,{once:true});
  window.addEventListener('resize',function(){if(activeTrigger&&popover&&popover.classList.contains('is-open'))positionPopover(activeTrigger);},{passive:true});
  window.addEventListener('scroll',function(){if(activeTrigger&&popover&&popover.classList.contains('is-open'))positionPopover(activeTrigger);},{passive:true});
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('variant:change',function(){window.setTimeout(function(){enhanceStock();if(activeTrigger)openPopover(activeTrigger);},40);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closePopover();});
})();
